import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import NoDecodableBooksImage from '@/assets/no-decodable-books.png';

export const ManageDecodableBooksNone = () => (
  <div className="flex flex-col gap-12 items-center">
    <h2 className="text-pt-primary text-3xl font-bold text-center">
      No Decodable Books For This Lesson.
    </h2>

    <p className="text-pt-primary text-lg">
      Browse more decodable books by{' '}
      <Link
        className="underline hover:no-underline"
        href="/manage/decodable-books"
      >
        clicking here
      </Link>
      .
    </p>

    <Image
      src={NoDecodableBooksImage}
      alt="No decodable books"
      width={400}
      height={400}
    />
  </div>
);
